export default "__VITE_ASSET__uHjsyeIt__"